let currentAudioId = null;
let currentAudioRef = null;
let currentAudioUrl = null;

export function getCurrentAudioState() {
    return { currentAudioId, currentAudioRef, currentAudioUrl };
}

export function setCurrentAudio(id, ref, url) {
    currentAudioId = id;
    currentAudioRef = ref;
    currentAudioUrl = url;
}

export function clearCurrentAudio() {
    if (currentAudioRef) {
        currentAudioRef.pause();
        currentAudioRef.currentTime = 0;
    }
    URL.revokeObjectURL(currentAudioUrl);
    currentAudioId = null;
    currentAudioRef = null;
    currentAudioUrl = null;
}

export function isAudioPlaying(id) {
    return currentAudioId === id && currentAudioRef && !currentAudioRef.paused;
}
